import React from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from '@link/share/components';
import LocaleRoute from '@link/metro-toei-pass/routes/LocaleRoute';
import styles from './base.module.css';

const BaseLayout: React.FC = () => {
  return (
    <LocaleRoute>
      <div className={styles.base}>
        <Header showMetroIcon={true} />
        <div className={styles.container}>
          <Outlet />
        </div>
      </div>
    </LocaleRoute>
  );
};

export default BaseLayout;
